import React, { Component } from "react";
import Popup from "./Popup";

class ButtonBloqueo extends Component {
    constructor(props) {
        super(props);

        /*Bindings de metodos a la clase*/
        this.bloquearTarjeta = this.bloquearTarjeta.bind(this);
    }
    /**
     * Bloquea una tarjeta
     * @param {any} motivoId Parametro int, representa el id del select con los motivos de bloqueo
     */
    bloquearTarjeta(motivoId) {
        const { actualizarNovedadEstado, codigoNovedad, entidadTipo, guardarNovedadBloqueo, novedad, tarjeta } = this.props;

        /*si existe una novedad recuperada quiere decir que el usuario la bloqueo en algun momento y la administradora la aprob� para finalmente ser bloqueada nuevamente... (?)*/
        if (novedad.novedadRecuperada) {
            actualizarNovedadEstado(novedad.novedadRecuperada.Id, 7, novedad.novedadRecuperada.NovedadCampoCodigo, entidadTipo, tarjeta.CuentaTarjetaId, true);
        } else {
            /*si existe una novedad cancelada, es decir, el usuario ya estuvo jugando con bloquear y recuperar..., siempre hay que actualizar*/
            if (novedad.novedadCancelada) {
                return guardarNovedadBloqueo({
                    ...novedad.novedadCancelada,
                    NovedadCampoCodigo: codigoNovedad,
                    EstadoId: 1,
                    ValorAnterior: novedad.novedadCancelada.ValorNovedad,
                    ValorNovedad: motivoId
                });
            } else {
                /*es la primera vez que entra hay que crear la novedad de bloqueo*/
                let nuevaNovedad = {
                    Id: null,
                    NovedadCampoCodigo: codigoNovedad,
                    ValorAnterior: null,
                    ValorNovedad: motivoId,
                    EstadoId: 1,
                    TarjetaCreditoId: tarjeta.TarjetaCreditoId,
                    CuentaTarjetaId: tarjeta.CuentaTarjetaId
                };

                return guardarNovedadBloqueo(nuevaNovedad);
            }
        }
    }
    /**
     * Metodo del ciclo de vida de react
     */
    render() {
        const { codigoNovedad, motivos, seIntentaEditar, tarjeta, novedad } = this.props;
        let componente = null;
        let puedeEjecutar = false;

        /*si existe una novedad que fue recuperada entonces puede ver los detalles de la tarjeta, de lo contrario tiene que revisar 
        las demas validaciones*/
        if (novedad.novedadBaja == undefined && novedad.novedadRecuperada) {
            puedeEjecutar = true;
        } else {
            puedeEjecutar = (novedad.novedadBaja == undefined
                && novedad.novedadBloqueda == undefined
                && novedad.validacionBaja == false
                && novedad.validacionBloqueo == false);
        }

        if (puedeEjecutar == false) {
            componente = (
                <a className="none-text-decoration ti-na disabled"></a>
            );
        } else {
            componente = (
                <Popup
                    clave={"popup-bloqueo-" + tarjeta.TarjetaCreditoId}
                    motivos={motivos}
                    titulo="Motivo de bloqueo"
                    mensajeError="Por favor, seleccione un motivo de bloqueo"

                    selectCombo={(value) => { this.props.selectCombo(2, codigoNovedad, value) }}
                    confirmar={(motivoId) => this.bloquearTarjeta(motivoId)}>

                    <a className="clickable none-text-decoration ti-na" data-toggle="dropdown"></a>
                </Popup>
            );
        }

        return componente;
    }
}

export default ButtonBloqueo;